




























import { deepEqual } from '@empathybroker/deep-equal';
import { RegularFilterValueConfig } from '@empathybroker/tsclient-play/dist/models/instance/filters/regular-filter-value-config';

import { FilterIdEnum } from '../../enums';

import { capitalizeSentence } from '../../filters';

import { RegularFilterConfig, RegularFilterSelectedValues } from '../../models';

import { UiCheckbox, UiSelect } from '../keen-ui';

export default {
  name: 'regular-filter-selector',
  components: {
    UiSelect,
    UiCheckbox
  },
  computed: {
    options: function (): any[] {
      const filterValuesMessages = this.$epb.messages.filters.values[this.filterConfig.id];
      const options = this.filterConfig.values.map((value: RegularFilterValueConfig) => {
        return {
          value: value.id,
          label: capitalizeSentence(value.prettyName || (!!filterValuesMessages && filterValuesMessages[value.id]) || value.id)
        };
      });
      if (!this.filterConfig.sortValuesDisabled) {
        options.sort((option1, option2) => {
          if (this.filterConfig.id === FilterIdEnum.DEVICE) {
            const deviceIds = Object.keys(this.$epb.messages.filters.values[FilterIdEnum.DEVICE]);
            return (deviceIds.indexOf(option1.value) - deviceIds.indexOf(option2.value));
          }
          return option1.label.localeCompare(option2.label);
        });
      }
      options.sort(this.sortOptions);
      if (this.filterConfig.multiselectDisabled && !this.filterConfig.mandatory) {
        options.unshift({
          label: (this.filterConfig.emptyMeansNone ? this.$epb.messages.filters.values.none : this.$epb.messages.filters.values.all)
        });
      }
      return options;
    },
    selectedOptions: function () {
      const selectedOptions = this.options.filter((option: any) => (this.filter.selectedValues.indexOf(option.value) >= 0));
      if (!!selectedOptions.length && this.filter.config.multiselectDisabled) {
        return selectedOptions[0];
      }
      return selectedOptions;
    },
    isMultiselect: function (): boolean {
      return !this.filter.config.multiselectDisabled;
    },
    label: function (): string {
      return capitalizeSentence(
        this.filter.config.prettyName ||
        this.$epb.messages.filters.names[this.filter.config.id] ||
        this.filter.config.id
      );
    }
  },
  props: {
    filter: Object,
    placeholder: String,
    showLabelAsPlaceholder: Boolean,
    disabled: Boolean
  },
  data: function () {
    return {
      filterConfig: undefined,
      optionTextTransitionTimePerPixel: 0.01
    };
  },
  methods: {
    onSelectedOptionsChange: function (selectedOptions: any): void {
      let selectedValues: RegularFilterSelectedValues = [];
      if (Array.isArray(selectedOptions)) {
        selectedValues = selectedOptions.map((selectedOption: any) => selectedOption.value);
      } else if (!!selectedOptions.value) {
        selectedValues = [selectedOptions.value];
      }
      this.$emit('selectedValuesChange', selectedValues);
    },
    onOptionMouseOver(event): void {
      const optionEl = event.currentTarget;
      const textEl = optionEl.lastChild;

      const optionWidth = optionEl.clientWidth;
      const textWidth = textEl.clientWidth;

      const translateLength = Math.min(optionWidth - textWidth, 0);
      const transitionDuration = `${ this.optionTextTransitionTimePerPixel * -translateLength }s`;

      textEl.style.transitionDuration = transitionDuration;
      textEl.style.transform = `translate3d(${ translateLength }px,0,0)`;
    },
    onOptionMouseLeave(event): void {
      const textEl = event.currentTarget.lastChild;
      textEl.style.transitionDuration = '0.3s';
      textEl.style.transform = 'translate3d(0,0,0)';
    }
  },
  watch: {
    'filter.config': {
      /*
       * We are forced to create a 'filterConfig' variable and update it ONLY IF its content has changed because the mutation of the
       * whole 'filters' param performed when selected values change fires a scroll reset inside the UiSelect component; 'filtersConfig'
       * variable is only used to calculate 'options' as that is the place where the reset scroll is performed inside UiSelect
       */
      handler: function (filterConfig: RegularFilterConfig): void {
        if (!deepEqual(filterConfig, this.filterConfig)) {
          this.filterConfig = filterConfig;
        }
      },
      deep: true,
      immediate: true
    }
  }
};

